import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PublicContext from '../PublicContext'
import MobileCreateSpecialistAppointmentPage from './Mobile/MobileCreateSpecialistAppointmentPage'
import ComputerCreateSpecialistAppointmentPage from './Computer/ComputerCreateSpecialistAppointmentPage'
import TabletCreateSpecialistAppointmentPage from './Tablet/TabletCreateSpecialistAppointmentPage'
import { screenSize } from '../../Common/Common'
import dayjs from 'dayjs'
import { post } from '../../Common/api'
import { useNavigate, useParams } from 'react-router'

export default function CreateSpecialistAppointmentPage () {
  const { box, setSiderTitle, data, setData, user } = useContext(PublicContext)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { boxId } = useParams()
  const [loading, setLoading] = useState(false)

  const onFinishFailed = () => {
    setLoading(false)
  }

  const sort = (optionA, optionB) => (
    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
  )

  const onFinish = (values) => {
    setLoading(true)
    const phone = values.phone
    if ((phone.slice(0, 3) === '+06') || (phone.slice(0, 3) === '+07')) {
      values.phone = '+33' + phone.slice(2)
    }
    setData({ ...data, country: values.country, civility: values.civility })
    values = {
      ...values,
      phone: values.phone.slice(1),
      box_id: box.id,
      is_now: false,
      specialist: true,
      created_by: user?.from || 'web'
    }
    post({
      url: 'public/appointments',
      params: values,
      onSuccess: (json) => {
        if (json.sms_confirmed) {
          navigate(`/appointments/${json.id}`)
        } else {
          navigate(`/box/${box.id}/confirm_appointment/${json.id}`)
        }
      }
    })
  }

  const civilityOptions = [
    { value: 'MR', label: 'M.' },
    { value: 'MS', label: 'Mme.' }
  ]

  const initialValues = {
    start_timestamp: data?.appointmentTime?.start,
    end_timestamp: data?.appointmentTime?.end,
    calendar_id: data?.calendarId,
    reason_id: data?.reasonId,
    date: dayjs(data?.appointmentTime?.time),
    country: 'FR'
  }

  useEffect(() => {
    setSiderTitle(t('Public.CreateAppointmentPage.title'))
  }, [])

  useEffect(() => {
    if (!data?.appointmentTime) {
      navigate(`/box/${boxId}/specialist`)
    }
  }, [data?.appointmentTime])

  const appointmentForm = {
    Mobile: MobileCreateSpecialistAppointmentPage,
    Computer: ComputerCreateSpecialistAppointmentPage,
    Tablet: TabletCreateSpecialistAppointmentPage
  }

  const ResponsiveForm = appointmentForm[screenSize()]

  return (
    <ResponsiveForm
      loading={loading}
      onFinishFailed={onFinishFailed}
      sort={sort}
      minimumAge={box?.teleconsulting_company_minimum_age}
      onFinish={onFinish}
      civilityOptions={civilityOptions}
      initialValues={initialValues}
    />
  )
}
